// Join class names, skipping falsy values: cn('a', cond && 'b') -> 'a b' | 'a'
export const cn = (...classes) => classes.filter(Boolean).join(' ');
